export default class DataResponse<T> {
  public data: T | null = null;
  public meta?: MetaInformation;

  public static fromObject<T>(data: T): DataResponse<T> {
    const response: DataResponse<T> = new DataResponse<T>();
    response.data = data;
    return response;
  }

  public static fromResponse<T>(response: object): DataResponse<T> {
    const dataResponse: DataResponse<T> = new DataResponse<T>();
    const rawResponse: { data: T, meta: MetaInformation } = response as { data: T, meta: MetaInformation };

    dataResponse.data = rawResponse.data;
    dataResponse.meta = rawResponse.meta;

    return dataResponse;
  }
}

export interface MetaInformation {
  current_page: number;
  from: number;
  last_page: number;
  per_page: number;
  total: number;
}

export interface RequestOptions {
  [key: string]: string | number | null | undefined

  //page is number type and minimal 1 value
  page?: string | number | null;
  include?: string;
}
